import React from "react";
import { Link, Outlet } from "react-router-dom";
// import "../../../css/admin.module.css";

const OrderManagement = () => (
  <div className="order-management">
    <h1>مدیریت سفارشات</h1>
    <div className="order-management-actions">
      <Link to="list" className="order-management-button">
        لیست سفارشات
      </Link>
      <Link to="add" className="order-management-button">
        افزودن سفارش
      </Link>
    </div>
    <div className="order-management-content">
      <Outlet />
    </div>
  </div>
);

export default OrderManagement;
